import dayjs from 'dayjs';
import { LOGIN_OTP_SESSION_UNTIL } from '../../../constants';
import { getStorageItem, removeStorageItem, setStorageItem } from 'utils';

export const LOGIN_OTP_SESSION_TTL_HOURS = 1;

export const setLoginOtpSessionTtl = (): void => {
  const expiresAt = dayjs().add(LOGIN_OTP_SESSION_TTL_HOURS, 'hour').toISOString();
  setStorageItem(LOGIN_OTP_SESSION_UNTIL, expiresAt);
};

/** Returns true when TTL is missing (legacy sessions) or past expiry. */
export const isLoginOtpSessionExpired = (): boolean => {
  const raw = getStorageItem(LOGIN_OTP_SESSION_UNTIL);

  if (!raw) {
    return true;
  }

  return dayjs(raw).isBefore(dayjs());
};

export const clearLoginOtpSessionTtl = (): void => {
  removeStorageItem(LOGIN_OTP_SESSION_UNTIL);
};
